import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { User } from '../models/user';
import { ApiCreateResult } from '../models/api-create-result';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private url = 'api/users';

  constructor(private http: HttpClient) { }

  query(): Observable<User[]> {
    return this.http.get<User[]>(this.url);
  }

  save(user: User): Observable<any> {
    if (!user.password) delete user.password;
    if (!user._id) {
      return this.http.post<ApiCreateResult>(this.url, user)
        .pipe(tap(res => user._id = res._id));
    }
    return this.http.put<any>(`${this.url}/${user._id}`, user);
  }

  delete(userId: string): Observable<any> {
    return this.http.delete<any>(`${this.url}/${userId}`);
  }

}
